import Cookies from 'js-cookie';
import { ObjectCell } from './data-cells';

// setting the 'WP-token' cookie is important for using the API server for
// several tasks, including accessing the admin site

// constants  -------------------------------------------------------------- //

const default_session = {
  api_config: null,
  branding: null,
  language: 'en',
  merchant: null,
  role: null,
  token: null,
  user: null,
};

const TOKEN_COOKIE_NAME = 'WP-token';

const STORE = window.localStorage;

// helper functions  ------------------------------------------------------- //

const store_var_name = session_var_name => `wp-${session_var_name}`;

// functions for manipulating session data --------------------------------- //

const read_session_var = key => {
  try {
    const session_var = store_var_name(key);
    const stored_data = STORE.getItem(session_var);

    return JSON.parse(stored_data);
  } catch (e) {
    return default_session[key];
  }
};

const write_session_var = (key, data) => {
  if (key === 'tracker') return;
  if (key === 'token') Cookies.set(TOKEN_COOKIE_NAME, data);

  return STORE.setItem(store_var_name(key), JSON.stringify(data));
};

const write_session_data = data => {
  session.merge(data);

  for (const key in data) {
    const value = data[key];
    write_session_var(key, value);
  }

  if ('user' in data && !!data.user) {
    write_session_var('language', data.user.language);
    write_session_var('role', data.user.last_role);
  }
};

const load_session = () => {
  const session_data = {};

  for (const k in default_session) {
    session_data[k] = read_session_var(k);
  }

  return session_data;
};

const start_session = data => {
  if ('user' in data && !!data.user) {
    data.language = data.user.language;
    data.role = data.user.last_role;
  }

  write_session_data(data);
};

const destroy_session = () => {
  Cookies.remove(TOKEN_COOKIE_NAME, { path: '/' });
  STORE.clear();
  write_session_data(default_session);
};

// make session  ----------------------------------------------------------- //

const make_session = data => {
  const loaded_session = load_session();
  const session_data = Object.assign({}, loaded_session, data);

  for (const key in session_data) {
    const value = session_data[key];
    write_session_var(key, value);
  }

  return ObjectCell(session_data);
};

// session object ---------------------------------------------------------- //

const session = {
  ...make_session({}),
  load: load_session,
  destroy: destroy_session,
  start: start_session,
  write: write_session_data,
};

// exports ----------------------------------------------------------------- //

export default session;
